var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldForms2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Field_Forms2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Field_Forms2",
    "data-name": "Field Forms2",
    clipPath: "url(#clip-Field_Forms2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(-2.311 -3.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(4.622 3.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21184",
    "data-name": "Path 21184",
    d: "M61.82.037a1.134,1.134,0,0,0-.561.322,1.137,1.137,0,0,0-.327.593c-.043.2-.043,11.517,0,11.716a1.214,1.214,0,0,0,.923.923c.2.043,8.269.043,8.471,0a1.225,1.225,0,0,0,.923-.923c.021-.1.029-1.386.029-4.408V3.991h-1.45c-.979,0-1.493-.011-1.588-.029a1.221,1.221,0,0,1-.923-.923c-.019-.1-.029-.609-.029-1.588V0L64.622,0C62.581.005,61.922.013,61.82.037Zm1.264,6.428a.42.42,0,0,1,.213.346.425.425,0,0,1-.4.4.451.451,0,0,1-.346-.218.38.38,0,0,1,.152-.516A.361.361,0,0,1,63.084,6.465Zm5.587,0a.387.387,0,0,1,0,.692,8.958,8.958,0,0,1-2.184.053H64.409L64.3,7.151a.385.385,0,0,1-.005-.676l.1-.064h2.083A8.977,8.977,0,0,1,68.671,6.465Zm-5.587,1.6a.42.42,0,0,1,.213.346.425.425,0,0,1-.4.4.451.451,0,0,1-.346-.218.38.38,0,0,1,.152-.516A.361.361,0,0,1,63.084,8.061Zm5.587,0a.387.387,0,0,1,0,.692,8.958,8.958,0,0,1-2.184.053H64.409L64.3,8.747a.385.385,0,0,1-.005-.676l.1-.064h2.083A8.977,8.977,0,0,1,68.671,8.061Zm-5.587,1.6A.42.42,0,0,1,63.3,10a.425.425,0,0,1-.4.4.451.451,0,0,1-.346-.218.38.38,0,0,1,.152-.516A.361.361,0,0,1,63.084,9.657Zm5.587,0a.387.387,0,0,1,0,.692,8.958,8.958,0,0,1-2.184.053H64.409l-.106-.059a.385.385,0,0,1-.005-.676l.1-.064h2.083A8.977,8.977,0,0,1,68.671,9.657Z",
    transform: "translate(-60.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21185",
    "data-name": "Path 21185",
    d: "M331,9.825c0,1.248,0,1.33.051,1.423a.429.429,0,0,0,.157.16l.106.059,1.32-.005,1.32-.008-1.476-1.477L331,8.5Z",
    transform: "translate(-323.814 -8.274)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldForms2);
export default __webpack_public_path__ + "static/media/FieldForms2.3dfd02a5379ecf3d9590c0cae0d7f50e.svg";
export { ForwardRef as ReactComponent };